export default __webpack_public_path__ + "static/media/add-timepoint.16d9482a.svg";